export default "__VITE_ASSET__DQbslxEV__"